import EnumDataSource from "../utils/enum-data-source.util";

export const PAYER_TYPE_PATIENT = 1;
export const PAYER_TYPE_INSURER = 2;

export const payerTypes = {
  [PAYER_TYPE_PATIENT]: "Patient",
  [PAYER_TYPE_INSURER]: "Insurer"
};

export const PAYER_TYPES = new EnumDataSource(payerTypes);

export const DEFAULT_PAYMENT_METHOD = 1;
export const CASH_PAYMENT_METHOD = 1;
export const CARD_PAYMENT_METHOD = 2;
export const DIRECT_DEPOSIT_PAYMENT_METHOD = 3;
export const CHECK_PAYMENT_METHOD = 4;
export const CARE_CREDIT_PAYMENT_METHOD = 5;
export const HEALTHIPLAN_PAYMENT_METHOD = 6;
export const WELLS_FARGO_PAYMENT_METHOD = 7;
export const ONLINE_PAYMENT_METHOD = 8;
export const EFT_PAYMENT_METHOD = 9;
export const PATIENT_CREDIT_PAYMENT_METHOD = 10;
export const ALLEGRO_PAYMENT_METHOD = 11;
export const VISA_PAYMENT_METHOD = 12;
export const MASTERCARD_PAYMENT_METHOD = 13;
export const AMERICAN_EXPRESS_PAYMENT_METHOD = 14;
export const DISCOVER_PAYMENT_METHOD = 15;
export const ACH_METHOD = 16;
export const ZELLE_PAYMENT_METHOD = 17;
export const VENMO_PAYMENT_METHOD = 18;
export const CHERRY_PAYMENT_METHOD = 19;
export const SQUARE_PAYMENT_METHOD = 20;
export const OTHER_PAYMENT_METHOD = 99;

export const paymentMethods = {
  [ACH_METHOD]: "ACH",
  [ALLEGRO_PAYMENT_METHOD]: "Allegro",
  [AMERICAN_EXPRESS_PAYMENT_METHOD]: "American Express",
  [CARD_PAYMENT_METHOD]: "Credit/Debit Card",
  [CARE_CREDIT_PAYMENT_METHOD]: "Financing - CareCredit",
  [CASH_PAYMENT_METHOD]: "Cash",
  [CHERRY_PAYMENT_METHOD]: "Financing - Cherry",
  [CHECK_PAYMENT_METHOD]: "Check",
  [DIRECT_DEPOSIT_PAYMENT_METHOD]: "Direct Deposit",
  [DISCOVER_PAYMENT_METHOD]: "Discover",
  [EFT_PAYMENT_METHOD]: "EFT",
  [HEALTHIPLAN_PAYMENT_METHOD]: "Financing - HealthiPlan",
  [MASTERCARD_PAYMENT_METHOD]: "Mastercard",
  [ONLINE_PAYMENT_METHOD]: "Online",
  [OTHER_PAYMENT_METHOD]: "Other",
  [PATIENT_CREDIT_PAYMENT_METHOD]: "Patient Credit",
  [SQUARE_PAYMENT_METHOD]: "Square",
  [VENMO_PAYMENT_METHOD]: "Venmo",
  [VISA_PAYMENT_METHOD]: "Visa",
  [WELLS_FARGO_PAYMENT_METHOD]: "Financing - Wells Fargo",
  [ZELLE_PAYMENT_METHOD]: "Zelle"
};

export const PAYMENT_METHODS = new EnumDataSource(paymentMethods);

export const PATIENT_PAYER_TYPE = PAYER_TYPE_PATIENT;
export const TILLED_PAYMENT_METHOD = 1;
export const JUSTIFI_PAYMENT_METHOD = 2;
export const GRAVITY_PAYMENT_METHOD = 3;
export const PAYMENT_LIST_KEY_DEFAULT = "paymentList";

// Resolve a clinic's card processor: the clinic's own value is authoritative, falling back
// to the practice's only when the clinic hasn't set one. Mirrors the backend's
// clinic→practice resolution (get_gravity_client). Single source of truth so the Gravity and
// Tilled gates can't drift apart on the clinic-vs-practice question.
export const resolveCardProcessingProvider = (clinic?: {
  card_processing_provider?: number;
  practice?: { card_processing_provider?: number } | null;
}): number | undefined =>
  clinic?.card_processing_provider ??
  clinic?.practice?.card_processing_provider;

export const CHARGE_METHOD_TERMINAL_VALUE = 1;
export const CHARGE_METHOD_ONLINE_VALUE = 2;

const chargeMethods = {
  [CHARGE_METHOD_TERMINAL_VALUE]: "Terminal Payment",
  [CHARGE_METHOD_ONLINE_VALUE]: "Non Terminal Payment"
};

export const CHARGE_METHODS = new EnumDataSource(chargeMethods);

export const ACH_DEBIT_ACCOUNT_TYPE_CHECKING = "checking";
export const ACH_DEBIT_ACCOUNT_TYPE_SAVINGS = "savings";

const achDebitAccountTypes = {
  [ACH_DEBIT_ACCOUNT_TYPE_CHECKING]: "Checking",
  [ACH_DEBIT_ACCOUNT_TYPE_SAVINGS]: "Savings"
};

export const ACH_DEBIT_ACCOUNT_TYPES = new EnumDataSource(achDebitAccountTypes);
